export const ugovor_o_djelu = {
    templateId: 44,
    category: 5,
    templateTitle: "Ugovor o djelu",
    templateDescription: `<p>Ugovorom o djelu izvođač se obvezuje obaviti određeni posao, kao što je izrada ili popravak neke stvari, izvršenje kakva fizičkog ili umnog rada i sl., a naručitelj se obvezuje platiti mu za to naknadu. Često se čini pogreška u razlikovanja ugovora u djelu u odnosu na ugovor o radu i ugovor o autorskom djelu.  </p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Ugovorom o djelu izvođač se obvezuje obaviti određeni posao, kao što je izrada ili popravak neke stvari, izvršenje kakva fizičkog ili umnog rada i sl., a naručitelj se obvezuje platiti mu za to naknadu.</p>
    <p>Iznimno je bitno razlikovati ugovor o djelu u odnosu na ugovor o radu.</p>
    <p>Sukladno Zakonu o radu, ako poslodavac s radnikom sklopi ugovor za obavljanje posla koji, s obzirom na narav i vrstu rada te ovlasti poslodavca, ima obilježja posla za koji se zasniva radni odnos, smatra se da je s radnikom sklopio ugovor o radu, osim ako poslodavac ne dokaže suprotno. Dakle, ukoliko poslodavac sklopi ugovor o djelu za posao koji elemente navedene u prethodnoj rečenici, smatra se da je skopljen ugovor o radu, a navedeno postupanje predstavlja i prekršaj.</p>
    <p>U pravilu se ugovor o djelu može sklopiti za ​obavljanje sljedećih poslova: djelatnosti trgovačkih putnika, akvizitera, sportskih sudaca i delegata, tumača, prevoditelja, turističkih djelatnika, konzultanata, sudskih vještaka, članova nadzornih odbora, skupština, povjerenstava i slično.</p>
    <p>Ugovor o djelu je ugovor obveznog, građanskog prava, koji se sklapa na temelju Zakona o obveznim odnosima.</p> 
    <p>Obilježja ugovora o djelu su:</p>
    <p>1. izvođač radi za naručitelja samostalno i neovisno o naručitelju djela,</p>
    <p>2. izvođač u pravilu ne obavlja poslove u radnom vremenu, nego prema svojoj organizaciji,</p>
    <p>3. izvođač posao obavlja osobno, ali ga može i povjeriti trećim osobama,</p>
    <p>4. za obavljeni posao izvođač prima naknadu najčešće po obavljenom poslu, odnosno poslije predaje djela,</p>
    <p>5. izvođač posao obavlja u prostoru kojeg sam odredi.</p>
    <br>

    <h5><strong>NAJČEŠĆE GREŠKE</strong></h5>
    <p><strong>- Sklapanje ugovora o djelu za poslove koji se smatraju ugovorom o radu - prekršaj prema Zakonu o radu</strong></p>
    <p>Pojašnjenje: ​ugovor o radu j​e radno-pravni ugovor koji se, u skladu sa Zakonom o radu, sklapa radi zasnivanja radnog odnosa. Obilježja radnog odnosa su:</p>
    <p>1. radnik radi uvijek i isključivo po uputama i pod nadzorom poslodavca (riječ je o odnosu podređenosti, odnosno subordinacije),</p>
    <p>2. radnik poslove obavlja u propisanom radnom vremenu, ugovorenom radnom vremenu ili radnom vremenu koje pisanom odlukom odredi poslodavac,</p>
    <p>3. radnik isključivo osobno obavlja poslove,</p>
    <p>4. poslodavac je za obavljeni rad dužan radniku isplaćivati plaću u novcu i u propisanim razdobljima (najmanje jednom mjesečno),</p>
    <p>5. radnik je dužan poslove obavljati u prostorijama poslodavca ili na nekom drugom mjestu koje je odredio poslodavac.</p>
    <br>
    <p>Podvrsta ugovora o djelu je i ugovor o izvođenju radova, a primjerak istoga možete vidjeti <a class="local-link" href="/contract?template=55">ovdje</a>.</p>

    
    <p><strong>- Sklapanje ugovora o djelu za poslove koji se smatraju poslovima u izradi autorskog djela </strong></p>
    <p>Pojašnjenje: razlika ugovora o djelu u odnosu na ugovor o autorskom djelu je u tome što su predmet ugovora o autorskom djelu autorska djela koja su originalna, duhovna (intelektualna) ostvarenja iz književnog, umjetničkog i znanstvenog područja, koja imaju individualni karakter i koji je na neki način izražen. Autorska djela su osobito: jezična djela (pisana djela, govorna djela, računalni programi), glazbena djela, s riječima ili bez riječi, dramska i dramsko-glazbena djela, koreografska i pantomimska djela, djela likovnih umjetnosti (s područja slikarstva, kiparstva i grafike), te ostala djela likovnih umjetnosti, djela arhitekture, djela primijenjenih umjetnosti i industrijskog dizajna, fotografska djela i djela proizvedena postupkom sličnom fotografskom, audiovizualna djela (kinematografska djela i djela stvorena na način sličan kinematografskom stvaranju), kartografska djela, prikazi znanstvene ili tehničke prirode kao što su crteži, planovi, skice, tablice i dr..</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o obveznim odnosima, Zakon o porezu na dohodaka, Zakon o doprinosima.</p>
  `,

    sides: [
        {
            prefix: 'Na temelju odredaba Zakona o obveznim odnosima,',
            signature: 'Naručitelj:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Naručitelj)',
            delimiter: `i`
        },
        {
            signature: 'Izvođač:',
            inputs: [{
                type: 'input',
                required: true,
                placeholder: 'Ime i prezime',
                inSignature: true,
            },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Ulica i kućni broj',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Mjesto',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'OIB',
                },
            ],
            suffix: ' (u daljnjem tekstu: Izvođač),'
        }
    ],

    headline: 'zaključuju sljedeći',
    title: 'UGOVOR O DJELU',
    noArticleNumbers: false,

    articles: [
        {
            title: 'PREDMET UGOVORA',
            mandatory: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {type: 'text', content: 'Izvođač se obvezuje za potrebe Naručitelja obaviti sljedeći posao:', required: true,},
                        {type: 'textarea', value: '', required: true,  help: 'S obzirom na gore prikazani tekst, ovdje upisujete predmet ugovora.'},
                    ],
                }],
            value: '',
        },   
        {
            title: 'NAČIN IZVRŠENJA',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Izvođač se obvezuje poslove iz ovog Ugovora izvršavati osobno kako je ugovoreno, prema svojem najboljem znanju i sposobnostima, poštujući važeće hrvatske propise i pravila struke.\r\nIzvođač se obvezuje u izvršenju djela uvažavati prijedloge i primjedbe Naručitelja.',
                    value: '',
                
            }],
        },
             
        {
            title: 'ROK IZVRŠENJA',
            mandatory: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {type: 'text', content: 'Izvođač se obvezuje djelo iz ovog Ugovora završiti do', required: true,},
                        {type: 'input', value: '', required: true, help: 'Upisati datum.'},
                    ],
                }],
            value: '',
        },
        {
            title: 'PRIMITAK, NEDOSTACI',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Nakon primitka djela odnosno pregleda obavljenog posla, Naručitelj će o svim možebitnim nedostacima odmah obavijestiti Izvođača.\r\nIzvođač se obvezuje ustanovljene nedostatke otkloniti u što kraćem roku.\r\nIzvođač ne snosi odgovornost za nedostatke koji su se mogli uočiti prilikom pregleda, osim ako je za njih znao, a nije ih pokazao Naručitelju.',
                    value: '',
                }],
        },
        {
            title: 'NAKNADA, DAVANJA',
            mandatory: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                                {type: 'text', content: 'Za poslove iz ovog Ugovora Naručitelj se obvezuje Izvođaču platiti naknadu u iznosu od'},
                                {type: 'input', value: '', required: true, help: 'Upišite iznos.'},
                                {type: 'text', content: '\r\nNaknada se isplaćuje na žiro-račun Izvođača, IBAN broj:'},
                                {type: 'input', value: '', required: true,},
                                {type: 'text', content: ', otvoren kod'},
                                {type: 'input', value: '', required: true, help: 'Upišite naziv banke u kojoj Izvođač ima otvoren žiro-račun.'},
                                {type: 'text', content: 'd.d..'},
                                {type: 'text', content: '\r\nNaknada se uplaćuje umanjenja za davanja na iznos naknade (doprinosi, predujam poreza na dohodak, prirez) koja snosi Naručitelj.'},

                            ],
                        }],
                    value: '',
                },
                {
                    title: 'ROK PLAĆANJA',
                    mandatory: true,
                    statements: [
                        {
                            type: 'choice',
                            mandatory: true,
                            editable: false,
                            choices: [
                                {
                                    parts: [
                                        {type: 'text', content: 'Naručitelj je dužan platiti Izvođaču naknadu u roku od'},
                                        {type: 'input', value: '', required: true, help: 'Upisati rok plaćanja.'},]
                                },
                                {
                                    parts: [
                                        {type: 'text', content: 'Naručitelj je dužan platiti Izvođaču naknadu u roku od '},
                                        {type: 'input', value: '', required: true, help: 'Upisati rok plaćanja.'},
                                        {type: 'text', content: 'od dana primitka izvršenog posla.'}]
                                },
                        {
                            parts: [
                              { type: "text", content: "Naručitelj je dužan platiti Izvođaču naknadu u sljedećim rokovima:" },
                              {type: "textarea", value: "", required: true },
                              { help: 'Upisati rokove plaćanja.'}
                            ]
                          }
                        ],
                        value: "",
                      },
                    ]
                  },
        {
            title: 'NADZOR NAD OBAVLJANJEM POSLOVA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Naručitelj ima pravo obavljati nadzor nad obavljanjem poslova i davati upute kad to odgovara prirodi posla, a Izvođač mu je dužan to omogućiti.',
                    value: '',
                }],
        },
        {
            title: 'ODSTUPANJE OD UGOVORENIH UVJETA',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {type: 'text', content: 'Ako se tijekom obavljanja poslova utvrdi da se Izvođač ne drži obveza iz ovog Ugovora, Naručitelj može upozoriti Izvođača ​i odrediti mu primjeran rok da svoj rad uskladi sa svojim obvezama. \r\nAko do isteka roka Izvođač ne postupi po zahtjevu Naručitelja, Naručitelj može raskinuti Ugovor u pisanom obliku uz otkazni rok od'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: 'dana i zahtijevati naknadu štete.'}],
                }],
        },
        {
            title: 'RASKID UGOVORA PRIJE ROKA',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {type: 'text', content: 'Izvršenje ovog Ugovora o roku predstavlja bitan sastojak ovog Ugovora. Ukoliko je Izvođač u zakašnjenju sa započinjanjem ili završetkom posla te je očito da ga neće završiti u roku, Naručitelj može raskinuti ugovor u pisanom obliku uz otkazni rok od'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: 'dana i zahtijevati naknadu štete.'}],
                }],
        },
        {
            title: 'OTKAZ UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Naručitelj je ovlašten u bilo koje vrijeme otkazati ovaj Ugovor, pisanim putem, uz otkazni rok od 7 (sedam) dana.',
                    value: '',
                }],
        },
        {
            title: 'DOSTAVA',
            mandatory: false,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'U slučaju otkaza i raskida Ugovora, isti se mora drugoj ugovornoj strani dostaviti preporučenom pošiljkom putem pošte na adresu označenu u ovom Ugovoru ili na drugi pouzdan način.\r\nU slučaju nemogućnosti uredne osobne dostave pisane opomene i dostave otkaza zbog promjene adrese, odbijanja preuzimanja pismena ili drugih načina izbjegavanja primanja pismena, dostava se smatra uredno izvršenom danom predaje preporučene pošiljke pošti, bez obzira na to je li pošta bila u mogućnosti uručiti pisanu opomenu, odnosno otkaz ili drugo pismeno.  ',
                    value: '',
                },
            ],
            value: '',
        }, 
        {
            title: 'PRESTANAK UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovaj Ugovor prestaje sljedećim slučajevima: \r\n- izvršenjem posla, \r\n- sporazumom ugovornih strana, \r\n- jednostranim raskidom ugovora, \r\n- otkazom ugovora.',
                    value: '',
                }],
        },
        {
            title: 'POSLOVNA TAJNA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovim Ugovorom, Izvođač se obvezuje čuvati povjerljive podatke do kojih je došao u izvršenju ovog Ugovora.\r\nPovjerljivi podaci su isključivo vlasništvo Naručitelja odnosno trećih osoba.',
                    value: '',
                }],
        },
        {
            title: 'NADLEŽNOST',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Naručitelja.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Izvođača.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u'
                                },
                                {type: 'input', value: '',help: "Upišite mjesno nadležni sud. Npr. ...sudom u Zagrebu; ...sudom u Splitu i sl..", required: true},
                        ]
                        }
                    ],
                    value: '',
                }
            ]
        },
        {
            title: 'MJERODAVNO PRAVO',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: false,
                    content: 'Na prava i obveze ugovornih stranaka, koja nisu uređena ovim ugovorom, primjenjuju se odredbe Zakona o obveznim odnosima koje se odnose na ugovor o djelu.',
                    value: '',
                }],
        },
        {
            title: 'PRIMJENA UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovaj Ugovor se primjenjuje od trenutka potpisa ugovornih strana.',
                    value: '',
                }],
        },
        {
            title: 'PRIMJERCI UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
                    value: '',
                }],
          },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
          {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
          }
        ],
      };


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/44_ugovor_o_djelu.ts